document.addEventListener('DOMContentLoaded', function () {
  function highlightMassyTier(qty) {
    const rows = document.querySelectorAll('.massy-volume-discount-price-table-body');
    rows.forEach(function (row) { row.classList.remove('active-tier'); });
    let activeRow = null;
    rows.forEach(function (row) {
      const firstCell = row.querySelector('td');
      if (!firstCell) return;
      const text = firstCell.textContent.trim();
      const numbers = text.match(/\d+/g);
      if (!numbers) return;
      const from = parseInt(numbers[0]);
      const to = numbers[1] ? parseInt(numbers[1]) : Infinity;
      if (qty >= from && qty <= to) activeRow = row;
    });
    if (activeRow) activeRow.classList.add('active-tier');
  }

  function bindQuantityWatcher() {
    const input = document.querySelector('quantity-selector-component input[name="quantity"]');
    if (!input) return;
    highlightMassyTier(parseInt(input.value) || 1);
    input.addEventListener('change', function () {
      highlightMassyTier(parseInt(this.value) || 1);
    });
    document.querySelectorAll('.quantity-minus, .quantity-plus, button[name="minus"], button[name="plus"]')
      .forEach(function (btn) {
        btn.addEventListener('click', function () {
          setTimeout(function () {
            highlightMassyTier(parseInt(input.value) || 1);
          }, 50);
        });
      });
  }

  const observer = new MutationObserver(function () {
    if (document.querySelector('.massy-volume-discount-price-table-body')) {
      observer.disconnect();
      bindQuantityWatcher();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Garde-fou : si le tableau Massy n'apparait jamais (produit sans palier
  // configure ou page non-produit), on arrete d'observer le DOM apres 5s au
  // lieu de tourner indefiniment (bug remonte dans l'audit du 2026-06-18).
  setTimeout(function () { observer.disconnect(); }, 5000);
});
